import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { GridComponentsModule } from 'app/pages/A2-utils/grid-components/grid-components.module';
import { BtnCellRendererComponent } from 'app/pages/A2-utils/grid-components/btn-cell-renderer/btn-cell-renderer.component';
import { GridLayoutManageComponent } from './grid-layout-manage.component';
import { GridLayoutMenuComponent } from './grid-layout-menu.component';
import { GridLayoutMenuService } from './grid-layout-menu.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AgGridModule.withComponents([BtnCellRendererComponent]),
    GridComponentsModule,
    Trip2ThemeModule
  ],
  declarations: [
    GridLayoutMenuComponent,
    GridLayoutManageComponent
  ],
  exports: [
    GridLayoutMenuComponent,
    GridLayoutManageComponent
  ],
  providers: [
    GridLayoutMenuService
  ]
})
export class GridLayoutMenuModule { }



// WEBPACK FOOTER //
// ./src/app/utils/grid-layout-menu/grid-layout-menu.module.ts